'use strict';

import React from 'react'

import Layout from '@Layout/FrontOffice'

import Image from '@Pure/Image'
import Link  from '@Pure/Link'

import PasswordRecoveryForm from '@/Form/PasswordRecoveryForm'

import FrontAuthCentered from '@/Wrapper/FrontAuthCentered'

export default class PasswordRecoveryPage extends React.Component
{
	constructor (props)
	{
		super(props);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		window.app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		let output =
		(
			<Layout page_title="Mot de passe oublié">

				<FrontAuthCentered>

					<div className="home-form registration">

						<div className="home-form__img-container">
							<Image className="home-form__img"
								src="/images/background/accueil_synergies@1500.jpg"
							/>
						</div>

						<PasswordRecoveryForm className="c-form form-registration"
							history={ props.history }
						/>

						<Link className="form-goto-home" href="/login">
							Page de connexion
						</Link>

					</div>

				</FrontAuthCentered>

			</Layout>
		);

		return output;
	}
}
